import { render, staticRenderFns } from "./LiveTripRoute.vue?vue&type=template&id=4aa99d8f&scoped=true&"
import script from "./LiveTripRoute.vue?vue&type=script&lang=js&"
export * from "./LiveTripRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa99d8f",
  null
  
)

export default component.exports